<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1356 4H10.5V21H12.1356V14L20.5 8.5L12.1356 4Z"
      fill="url(#paint0_linear_9995_23795)"
    />
    <path
      d="M8.51863 11H9.5V21H8.51863V16.8824L3.5 13.6471L8.51863 11Z"
      fill="url(#paint1_linear_9995_23795)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9995_23795"
        x1="17.6427"
        y1="24.0001"
        x2="17.6427"
        y2="4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F414B" />
        <stop offset="1" stop-color="#6F727E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9995_23795"
        x1="5.21436"
        y1="22.7647"
        x2="5.21436"
        y2="11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F414B" />
        <stop offset="1" stop-color="#6F727E" />
      </linearGradient>
    </defs>
  </svg>
</template>
